/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_End_DescriptionInputs */

const es_admin_billing_bills_list_end_description = /** @type {(inputs: Admin_Billing_Bills_List_End_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llegaste al final del historial de facturación.`)
};

const en_admin_billing_bills_list_end_description = /** @type {(inputs: Admin_Billing_Bills_List_End_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've reached the end of your billing history.`)
};

/**
* | output |
* | --- |
* | "You've reached the end of your billing history." |
*
* @param {Admin_Billing_Bills_List_End_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_end_description = /** @type {((inputs?: Admin_Billing_Bills_List_End_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_End_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_end_description(inputs)
	return en_admin_billing_bills_list_end_description(inputs)
});
export { admin_billing_bills_list_end_description as "admin.billing.bills_list.end_description" }